import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
export function SiteLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-paper" data-id="element-156" data-mp="39v0nd6kh96mb">
      <Header data-id="element-157" data-mp="39segza9box5o" />
      <main className="flex-1" data-id="element-158" data-mp="3dw2ndpm7xmpc">
        <Outlet data-id="element-159" data-mp="3dwuikzbwlif3" />
      </main>
      <Footer data-id="element-160" data-mp="3dvjfl1qa8ep1" />
    </div>;
}